"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var gl_resource_1 = __importDefault(require("./gl-resource"));
var FBO = (function (_super) {
    __extends(FBO, _super);
    function FBO(gl, width, height) {
        var _this = _super.call(this, gl) || this;
        _this.id = gl.createFramebuffer();
        _this.width = width;
        _this.height = height;
        return _this;
    }
    FBO.prototype.bind = function (colorBuffers, depthBuffer) {
        if (depthBuffer === void 0) { depthBuffer = null; }
        var gl = _super.prototype.gl.call(this);
        gl.bindFramebuffer(gl.FRAMEBUFFER, this.id);
        gl.viewport(0, 0, this.width, this.height);
        for (var i = 0; i < colorBuffers.length; ++i) {
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl['COLOR_ATTACHMENT' + i], gl.TEXTURE_2D, colorBuffers[i], 0);
        }
        if (depthBuffer) {
            gl.bindRenderbuffer(gl.RENDERBUFFER, depthBuffer);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, depthBuffer);
        }
    };
    FBO.bindDefault = function (gl) {
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    };
    FBO.prototype.freeGLResources = function () {
        _super.prototype.gl.call(this).deleteFramebuffer(this.id);
        this.id = null;
    };
    return FBO;
}(gl_resource_1.default));
exports.default = FBO;
